import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const RoleListTemplate = ({ t, viewStore, viewStore: { loading, listStore, tableData, queryUtility } }) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<div className="layout__main__subheader">
				<h2 className="layout__main__subheader__title">{t('MAINMENU.ADMINISTRATION.ROLES')}</h2>
			</div>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
				}}
				data={listStore.data.slice()}
			/>
		</section>
	);
};

export default defaultTemplate(RoleListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/role/pages/RoleListTemplate.jsx